import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="choices-select"
export default class extends Controller {
  static values = {
    options: Object,
  };

  initialize() {
    this.originalChoices = Array.from(this.element.options).map((opt) => ({
      value: opt.value,
      label: opt.text,
    }));

    // choices.js is loaded on demand. Callers (variant-selector) may invoke
    // reset/filterByIds before it arrives, so both chain onto this promise.
    this.ready = import("choices.js").then(({ default: Choices }) => {
      this.choices = new Choices(this.element, this.optionsValue);
      return this.choices;
    });
  }

  reset() {
    this.ready.then((choices) => choices.setChoiceByValue(""));
  }

  filterByIds(validIds) {
    const filtered = this.originalChoices.filter(
      (choice) => choice.value !== "" && validIds.has(Number(choice.value)),
    );
    this.ready.then((choices) => choices.setChoices(filtered, "value", "label", true));
  }
}
